<template>
  <div class="topNav" v-show="navShow">
    <ul>
      <li>
        <router-link to="/reservation">{{$t('New Reservation')}}</router-link>
      </li>
      <li>
        <router-link to="/orders/search">{{$t('Reservation Search')}}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "topNav",
    computed: {
      navShow() {
        return this.$route.path !== '/'
      }
    }
  }
</script>
